class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const tabs = this.querySelectorAll(".tab-link");
    const panes = this.querySelectorAll(".tab-panel");

    if (tabs.length === 0 || panes.length === 0) return;

    // --- set initial state (first tab active) ---
    tabs.forEach((t, i) => {
      if (i === 0) {
        t.classList.add("active", "button");
        t.classList.remove("button-secondary");
      } else {
        t.classList.remove("active", "button");
        t.classList.add("button-secondary");
      }
    });

    panes.forEach((p, i) => {
      if (i === 0) {
        p.classList.add("active");
      } else {
        p.classList.remove("active");
      }
    });

    // --- add click behavior ---
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => {
          t.classList.remove("active", "button");
          t.classList.add("button-secondary");
        });

        panes.forEach(p => p.classList.remove("active"));

        tab.classList.add("active", "button");
        tab.classList.remove("button-secondary");

        this.querySelector(`#${tab.dataset.tab}`)?.classList.add("active");
      });
    });
  }
}

customElements.define("product-tabs", ProductTabs);